module.exports = __webpack_public_path__ + "static/vegetace4-3a88bec93108a0d04cc0fee00058b535.jpg";